"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _StyledLink = require("./StyledLink");
Object.keys(_StyledLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StyledLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StyledLink[key];
    }
  });
});
